import React from 'react';
import ImageBlock from './ImageBlock';
import VideoBlock from './VideoBlock';

const SideBySideBlock = ({ block }) => {
  if (!block) return null;

  const { image, video, layout = 'side-by-side', gap = 4 } = block;
  

  const gapClasses = {
    2: 'gap-2',
    4: 'gap-4',
    6: 'gap-6',
    8: 'gap-8'
  };
  const gapClass = gapClasses[gap] || 'gap-4';
  
  const containerClass = layout === 'side-by-side' 
    ? `flex flex-col md:flex-row ${gapClass} items-start`
    : `flex flex-col ${gapClass} items-center`;

  return (
    <div className={`mb-6 ${containerClass}`}>
      
      {video && (
        <div className={layout === 'side-by-side' ? 'flex-1 w-full md:w-1/2' : 'w-full'}>
          <VideoBlock block={video} />
        </div>
      )}
      
      {image && (
        <div className={layout === 'side-by-side' ? 'flex-1 w-full md:w-1/2' : 'w-full'}>
          <ImageBlock block={image} />
        </div>
      )}
    </div>
  );
};

export default SideBySideBlock;

